import React from "react";
import {
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Typography,
  Paper,
  IconButton,
  Tooltip,
} from "@mui/material";
import {
  PictureAsPdf as PdfIcon,
  Image as ImageIcon,
  Description as DocIcon,
  InsertDriveFile as FileIcon,
  Visibility as VisibilityIcon,
} from "@mui/icons-material";
import { useTranslation } from "react-i18next";

const AttachmentItem = ({ attachment, onPreview }) => {
  const { t } = useTranslation();

  const getFileIcon = (fileName) => {
    if (fileName.endsWith(".pdf")) return <PdfIcon color="error" />;
    if (fileName.endsWith(".jpg") || fileName.endsWith(".jpeg") || fileName.endsWith(".png")) return <ImageIcon color="info" />;
    if (fileName.endsWith(".doc") || fileName.endsWith(".docx")) return <DocIcon color="primary" />;
    return <FileIcon color="action" />;
  };

  const handlePreview = () => {
    // Assuming the fileUrl is a relative path, construct the full URL
    const fullUrl = `${window.location.origin}/${attachment.fileUrl}`;
    onPreview({
      name: attachment.fileName,
      path: fullUrl,
      type: attachment.fileName.split('.').pop()
    });
  };

  return (
    <ListItem
      secondaryAction={
        <Tooltip title={t("Preview")}>
          <IconButton edge="end" aria-label="preview" onClick={handlePreview}>
            <VisibilityIcon />
          </IconButton>
        </Tooltip>
      }
      sx={{
        "&:hover": {
          backgroundColor: "action.hover",
        },
        borderRadius: 1,
        mb: 0.5,
      }}
    >
      <ListItemIcon>{getFileIcon(attachment.fileName)}</ListItemIcon>
      <ListItemText
        primary={attachment.fileName}
        secondary={`${t("Type")}: ${attachment.attachmentTypeName} | ${t("Date")}: ${new Date(
          attachment.uploadDate
        ).toLocaleDateString()}`}
      />
    </ListItem>
  );
};

const AttachmentsDisplay = ({ attachments, onPreview }) => {
  const { t } = useTranslation();

  if (!attachments || attachments.length === 0) {
    return <Typography variant="body2">{t("NoAttachmentsFound")}</Typography>;
  }

  return (
    <Paper elevation={2} sx={{ p: 2, mt: 2 }}>
      <Typography variant="h6" gutterBottom>
        {t("YourAttachments")}
      </Typography>
      <List dense>
        {attachments.map((att) => (
          <AttachmentItem key={att.attachmentId} attachment={att} onPreview={onPreview} />
        ))}
      </List>
    </Paper>
  );
};

export default AttachmentsDisplay;
